import {
  Card,
  CopyValue,
  HeaderDetail,
  StatusBadge,
} from "@bagel-web/components";
import { CommonAPIRequest } from "../types";
import { util } from "..";

const APIRequestHeaderCard = ({
  apiRequest,
}: {
  apiRequest: CommonAPIRequest;
}) => {
  return (
    <>
      <Card colSpan={2}>
        <HeaderDetail>
          <HeaderDetail.Field label="Method">
            <code>{apiRequest.req_method}</code>
          </HeaderDetail.Field>

          <HeaderDetail.Field label="Response Status">
            <StatusBadge
              statusCode={apiRequest.res_status_code}
              created={apiRequest.created}
            />
          </HeaderDetail.Field>

          <HeaderDetail.Field label="Request Path">
            <CopyValue>{apiRequest.req_path}</CopyValue>
          </HeaderDetail.Field>

          <HeaderDetail.Field label="Received At">
            {util.formatTimestamp(apiRequest.created)}
          </HeaderDetail.Field>

          {apiRequest.trace_id && apiRequest.trace_url && (
            <HeaderDetail.Field label="Trace">
              <a href={apiRequest.trace_url} target="_blank" rel="noreferrer">
                <code>{apiRequest.trace_id}</code>
                <i className="bi-box-arrow-up-right ms-3" />
              </a>
            </HeaderDetail.Field>
          )}
        </HeaderDetail>
      </Card>
    </>
  );
};

export default APIRequestHeaderCard;
